import { dialogOpen } from '../actions/creators/dialogs';
import * as actions from '../actions/types';
import CMX from '../api';
import { onApiError } from './misc';

export const userWalletMiddleware = ({ getState, dispatch }) => next => async action => {
    next(action);

    switch (action.type) {
        case actions.USER_WALLET_ADD_CARD_VALIDATE: return addCardValidate(action, getState, dispatch);
        case actions.USER_WALLET_ADD_CARD_CONFIRM: return addCardConfirm(action, getState, dispatch);
        case actions.USER_WALLET_ADD_CARD_CONFIRM_SUCCESS: return addCardSuccess(action, getState, dispatch);
        case actions.USER_WALLET_CARD_PIN_REQUEST: return cardPinRequest(action, getState, dispatch);
        case actions.USER_WALLET_CARD_PIN_REQUEST_ERROR:
        case actions.USER_WALLET_CARDS_FETCH_ERROR:
        case actions.USER_WALLET_CARD_REMOVE_ERROR:
        case actions.USER_WALLET_CARD_BALANCE_FETCH_ERROR:
        case actions.USER_WALLET_ADD_CARD_VALIDATE_ERROR:
        case actions.USER_WALLET_ADD_CARD_CONFIRM_ERROR: return onApiError(dispatch, action);
        default: return;
    }
};

function addCardValidate(action, getState, dispatch) {
    const { type, cardNumber, pin, expirationDate } = action.payload;

    const payload = { type, cardNumber };

    if (pin) payload['pin'] = pin;
    if (expirationDate) payload['expirationDate'] = expirationDate;

    CMX.post('/me/wallet/add-card/validate', payload)
        .then((response) => {
            ('giftCard' in response) && dispatch({ type: actions.USER_WALLET_ADD_CARD_VALIDATE_SUCCESS, payload: response.giftCard });
        })
        .catch((error) => {
            dispatch({ type: actions.USER_WALLET_ADD_CARD_VALIDATE_ERROR, error });
        });
}

function addCardConfirm(action, getState, dispatch) {
    const { type, cardNumber, pin, expirationDate } = action.payload;

    const payload = { type, cardNumber };

    if (pin) payload['pin'] = pin;
    if (expirationDate) payload['expirationDate'] = expirationDate;

    CMX.post('/me/wallet/add-card/confirm', payload)
        .then((response) => {
            ('card' in response) && dispatch({ type: actions.USER_WALLET_ADD_CARD_CONFIRM_SUCCESS });
        })
        .catch((error) => {
            dispatch({ type: actions.USER_WALLET_ADD_CARD_CONFIRM_ERROR, error });
        });
}

function addCardSuccess(action, getState, dispatch) {
  dispatch(dialogOpen({
    message: 'Tu tarjeta se agregó a tu wallet con éxito.',
    icon: 'party-horn',
    buttons: [
        {
            label: 'Continuar',
            primary: true,
            onClick: (dialog) => {
                document.location.href = '/usuario/wallet';
            }
        },
    ]
  }));
}

function cardPinRequest(action, getState, dispatch) {
    return CMX.post(`/me/wallet/cards/${action.id}/getPin`, ('auth_pin' in action) ? { auth_pin: action.auth_pin } : {})
        .then((response: any) => {
            dispatch({
                type: actions.USER_WALLET_CARD_PIN_REQUEST_SUCCESS,
                payload: response,
                id: action.id,
            });
        }).catch((error: any) => {
            dispatch({
                type: actions.USER_WALLET_CARD_PIN_REQUEST_ERROR,
                error,
                id: action.id,
                originalAction: action,
            });
        });
}

export default userWalletMiddleware;